import React from 'react';
import {connect} from 'react-redux';
import cx from 'classnames';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faPlus, faSlidersH} from "@fortawesome/free-solid-svg-icons";
import {Button} from "reactstrap";
import {Link} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import LanguageSelect from "../AppHeader/Components/LanguageSelect";


const PageTitle = (
    {
        heading,
        icon,
        subheading,
        subButton,
        enablePageTitleCreationButton,
        headerButtonCreateUrl,
        headerButtonCreateCallback = () => {},

        enablePageTitleSettingsButton,
        headerButtonSettingsUrl,

        enablePageTitleBackButton,
        headerButtonBackUrl,

        // Map state to props
        enablePageTitleIcon,
        enablePageTitleSubheading,
    }
) => {
    const {t, i18n} = useTranslation();

    let buttons = [];
    if (enablePageTitleCreationButton && headerButtonCreateUrl) {
        buttons.push(<Link to={headerButtonCreateUrl} key={1} className="btn btn-success btn-lg custom-hover-success" onClick={headerButtonCreateCallback}>
            <FontAwesomeIcon icon={faPlus}/>
            &nbsp;&nbsp;{t('layout.page_title.button_create', 'Create')}
        </Link>);
    }

    if (enablePageTitleSettingsButton && headerButtonSettingsUrl) {
        buttons.push(<Link to={headerButtonSettingsUrl} key={2} className="btn btn-outline-success">
            <FontAwesomeIcon icon={faSlidersH}/>
            &nbsp;&nbsp;{t('layout.page_title.button_settings', 'Settings')}
        </Link>);
    }

    if (enablePageTitleBackButton && headerButtonBackUrl) {
        buttons.push(<Link to={headerButtonBackUrl} key={3} className="btn btn-outline-success">
            <FontAwesomeIcon icon={faArrowLeft}/>
            &nbsp;&nbsp;{t('layout.page_title.button_back', 'Back')}
        </Link>);
    }

    return <div className="app-page-title">
        <div className="page-title-wrapper">
            <div className="page-title-heading">
                {icon ? <div className={cx("page-title-icon", {'d-none': !enablePageTitleIcon})}>
                    <i className={icon}/>
                </div> : null}
                <div>
                    <div>
                        {heading} {subButton}
                    </div>
                    {subheading && <div className={cx("page-title-subheading", {'d-none': !enablePageTitleSubheading})}>
                        {subheading}
                    </div>}
                </div>
            </div>

            <div className="page-title-actions">
                <div className="d-flex flex-column flex-lg-row">
                    <LanguageSelect/>
                    {buttons}
                </div>
            </div>
        </div>
    </div>
}

const mapStateToProps = state => ({
    enablePageTitleIcon: state.ThemeOptions.enablePageTitleIcon,
    enablePageTitleSubheading: state.ThemeOptions.enablePageTitleSubheading,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PageTitle);